(function() {
  var css = '.bee-product-form__buttons:has(.bee-pr__notify-stock:not(.bee-d-none):not([style*="display: none"]):not([style*="display:none"])) .bee-pr__qty_cart' +
    '{display:none!important}' +
    '.bee-product-form__buttons .bee-pr__notify-stock:not(.bee-d-none):not([style*="display: none"]):not([style*="display:none"])' +
    '{display:flex!important;width:100%;align-items:center;justify-content:center;' +
    'background-color:var(--accent-color)!important;color:var(--bee-light-color)!important;' +
    'border:none;cursor:pointer;padding:0 30px;min-height:50px;' +
    'font-size:inherit;font-family:inherit;text-transform:uppercase;letter-spacing:inherit}';

  var s = document.createElement('style');
  s.textContent = css;
  document.head.appendChild(s);

  /* Global-E: hide free shipping bar for international shoppers */
  function addGeHideClasses() {
    var els = document.querySelectorAll('.bee-cart__threshold');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].classList.contains('ge-hide')) {
        els[i].classList.add('ge-hide');
      }
    }
  }
  addGeHideClasses();
  document.addEventListener('DOMContentLoaded', addGeHideClasses);
  new MutationObserver(function() { addGeHideClasses(); }).observe(document.documentElement, { childList: true, subtree: true });

  function updateNotifyText() {
    var btns = document.querySelectorAll('.bee-pr__notify-stock');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].style.display !== 'none' && !btns[i].classList.contains('bee-d-none')) {
        btns[i].textContent = 'NOTIFY ME';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(updateNotifyText, 1200);
  });

  var check = setInterval(function() {
    if (window.jQuery_BENT || window.jQuery) {
      clearInterval(check);
      var $ = window.jQuery_BENT || window.jQuery;
      $(document).on('variant:changed', function(evt) {
        if (evt.currentVariant && !evt.currentVariant.available) {
          setTimeout(updateNotifyText, 150);
        }
      });
    }
  }, 200);
})();
